
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'thunderstorm': {
    width: 100,
    height: 100,
    viewBox: '0 0 100 100',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M59.999 65.641h-1.062l3.585-4.412c3.181-1.057 5.477-4.053 5.477-7.588A7.998 7.998 0 0 0 60 45.643c-1.601 0-3.083.48-4.333 1.29-1.232-5.316-5.974-9.29-11.665-9.29-6.626 0-11.998 5.372-11.998 12 0 5.446 3.632 10.038 8.604 11.504l-1.349 3.777c-6.52-2.021-11.255-8.098-11.255-15.282 0-8.835 7.163-15.999 15.998-15.999 6.004 0 11.229 3.312 13.965 8.204.664-.114 1.337-.205 2.033-.205 6.627 0 11.999 5.371 11.999 11.998s-5.373 12.001-12 12.001zm-11.998-14h9.998l-5.999 10h6.999L46.001 77.639l3.6-11.998h-6.6l5-14z"/>'
  }
})
